import { CIcon } from '~/icons/types'

export const ciBoatTug: CIcon = {
  width: '24',
  height: '24',
  paths: [
    {
      d:
        'M23.239 12.264h-5.21V8.318h.841a.5.5 0 1 0 0-1h-4.466V4.5a.5.5 0 0 0-1 0v2.818h-3.6a.5.5 0 0 0-.5.5.5.5 0 0 0 .472.495v3.951H6.088a.5.5 0 0 0 0 1h.582v2.013H5.63a1.714 1.714 0 0 0-1.634-1.216 1.713 1.713 0 0 0-1.633 1.216H.501a.5.5 0 0 0-.5.5v3.046a1.777 1.777 0 0 0 1.775 1.774h14.406a7.565 7.565 0 0 0 7.557-7.557v-.276a.5.5 0 0 0-.5-.5Zm-6.21-3.946v3.946h-2.117a.5.5 0 0 0-.457.3l-1.205 2.713h-1.338a1.712 1.712 0 0 0-1.133-1.133V8.319l6.25-.001Zm-6.75 6.742a.717.717 0 1 1-.002 1.434.717.717 0 0 1 .002-1.434ZM7.67 13.264h2.109v.879a1.712 1.712 0 0 0-1.134 1.134H7.67v-2.013Zm-3.671 1.8a.717.717 0 1 1-.719.713.717.717 0 0 1 .716-.717l.003.004Zm12.183 4.533H1.776a.776.776 0 0 1-.775-.775v-2.545h1.362a1.712 1.712 0 0 0 1.633 1.217 1.714 1.714 0 0 0 1.634-1.217h3.015a1.714 1.714 0 0 0 1.634 1.217 1.712 1.712 0 0 0 1.633-1.217h1.663a.5.5 0 0 0 .457-.3l1.206-2.716h7.5a6.565 6.565 0 0 1-6.556 6.336Z'
    },
    {
      d:
        'M17.529 17.49a1.718 1.718 0 0 0 1.213-2.928 1.718 1.718 0 0 0-2.426 0 1.718 1.718 0 0 0-.504 1.213 1.72 1.72 0 0 0 1.717 1.716Zm0-2.432a.717.717 0 1 1-.002 1.434.717.717 0 0 1 .002-1.434Z'
    }
  ],
  ellipses: [],
  circles: [],
  name: 'boat-tug',
  type: 'thin'
}
